module.exports = __webpack_public_path__ + "img/liwenting.ecafdfb4.jpg";